/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { MessagingChannel } from "./MessagingChannel";
import {
  MessagingChannelFromJSON,
  MessagingChannelFromJSONTyped,
  MessagingChannelToJSON,
  MessagingChannelToJSONTyped,
} from "./MessagingChannel";

/**
 *
 * @export
 * @interface WhatsAppEntry
 */
export interface WhatsAppEntry {
  /**
   * Gondola's business telephone number in canonical E.164.
   * @type {string}
   * @memberof WhatsAppEntry
   */
  destination: string;
  /**
   *
   * @type {string}
   * @memberof WhatsAppEntry
   */
  prefillText: string;
  /**
   *
   * @type {MessagingChannel}
   * @memberof WhatsAppEntry
   */
  channel?: MessagingChannel | null;
}

/**
 * Check if a given object implements the WhatsAppEntry interface.
 */
export function instanceOfWhatsAppEntry(value: object): value is WhatsAppEntry {
  if (!("destination" in value) || value["destination"] === undefined)
    return false;
  if (!("prefillText" in value) || value["prefillText"] === undefined)
    return false;
  return true;
}

export function WhatsAppEntryFromJSON(json: any): WhatsAppEntry {
  return WhatsAppEntryFromJSONTyped(json, false);
}

export function WhatsAppEntryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): WhatsAppEntry {
  if (json == null) {
    return json;
  }
  return {
    destination: json["destination"],
    prefillText: json["prefill_text"],
    channel:
      json["channel"] == null
        ? undefined
        : MessagingChannelFromJSON(json["channel"]),
  };
}

export function WhatsAppEntryToJSON(json: any): WhatsAppEntry {
  return WhatsAppEntryToJSONTyped(json, false);
}

export function WhatsAppEntryToJSONTyped(
  value?: WhatsAppEntry | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    destination: value["destination"],
    prefill_text: value["prefillText"],
    channel: MessagingChannelToJSON(value["channel"]),
  };
}
